export default "__VITE_ASSET__BriPdPyE__"